/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  MediaActionTypes,
  MediaState,
  GetMediaParams,
  GetMediaSuccess,
  GetMediaPending,
  MediaTypes
} from './types';

// Actions
export const actions = {
  getMedia: (payload: GetMediaParams): MediaActionTypes => ({
    type: types.GET_MEDIA.REQUEST,
    payload
  }),
  resetAction: () => ({ type: types.RESET_ACTION }),
  resetMedia: () => ({ type: types.RESET_MEDIA })
};

// Initial State
export const initialState: MediaState = {
  action: {
    pending: false,
    error: null
  },
  attractImage: [],
  attractVideo: [],
  event: [],
  venue: [],
  genre: [],
  inactiveImage: [],
  splashImage: [],
  backgroundImage: [],
  logoImage: [],
  promoCodeImage: []
};

// Reducer
export const reducer = (state: MediaState = initialState, action: MediaActionTypes): MediaState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
      case types.RESET_MEDIA:
        draft.action = initialState.action;
        draft.event = initialState.event;
        draft.attractImage = initialState.attractImage;
        draft.attractVideo = initialState.attractVideo;
        draft.venue = initialState.venue;
        draft.genre = initialState.genre;
        draft.inactiveImage = initialState.inactiveImage;
        draft.splashImage = initialState.splashImage;
        draft.backgroundImage = initialState.backgroundImage;
        draft.logoImage = initialState.logoImage;
        draft.promoCodeImage = initialState.promoCodeImage;
        break;
      case types.GET_MEDIA.PENDING:
        draft.action.pending = (action as GetMediaPending).payload;
        break;
      case types.GET_MEDIA.SUCCESS:
        const imageResponse = (action as GetMediaSuccess).payload;
        draft.event = imageResponse.event;
        draft.venue = imageResponse.venue;
        draft.genre = imageResponse.genre;
        draft.attractImage = imageResponse[MediaTypes.ATTRACT_IMAGE];
        draft.attractVideo = imageResponse[MediaTypes.ATTRACT_VIDEO];
        draft.inactiveImage = imageResponse[MediaTypes.INACTIVE_IMAGE];
        draft.splashImage = imageResponse[MediaTypes.SPLASH_IMAGE];
        draft.backgroundImage = imageResponse[MediaTypes.BACKGROUND_IMAGE];
        draft.logoImage = imageResponse[MediaTypes.LOGO_IMAGE];
        draft.promoCodeImage = imageResponse[MediaTypes.PROMO_CODE_IMAGE];
        break;
    }
  });
};
